define([
	"dojo/_base/declare",
	"csi/action",
	"csi/html",
	"csi/locale",
	"csi/middleware/customView/options/CustomViewOptionsStore",
	"csi/middleware/customView/options/DefaultOptionsTab",
	"csi/view/_CustomViewMixin",
	"csi/view/_CustomViewQueryMixin",
	"csi/view/_QueryMixin",
	"csi/view/Widget",
	"./Preferences",
	"dojo/text!csi/templates/chart.html"
], function (declare, csiAction, html, locale, CustomViewOptionsStore, DefaultOptionsTab, _CustomViewMixin, _CustomViewQueryMixin, _QueryMixin, Widget, Preferences, template) {

	csiAction.registerControllers("Chart", {
		CustomViewManage: "csi/chart/ChartCustomViewController"
	});

	return declare([Widget, _CustomViewMixin, _QueryMixin, _CustomViewQueryMixin], {
		customViewOptionsComponent: DefaultOptionsTab,
		customViewOptionsStore: CustomViewOptionsStore,
		plugins: ['print', 'pdf', 'refresh'],
		pluginsRight: ['print', 'pdf'],
		prefClass: Preferences,
		templateString: template,

		// connection points
		chartNode: null,
		contentNode: null,

		// fusion chart object
		_fusionChart: null,

		/**
		 * @override
		 * Attributes in view cannot be edited
		 */
		onCustomViewAttributeOptions(options) {
			options.fixed = true;
			this.inherited(arguments);
		},

		onData: function (/*QueryResults*/results) {
			// summary: extension point for rendering chart with results from query
		},

		/**
		 * Load data and render the chart or a "no data" placeholder
		 * @override
		 */
		_buildView: function () {
			this.when(this._query(), (results) => {
				if (this.get("contentMessage")) {
					html.destroyChildren(this.chartNode);
					Widget.prototype._buildView.call(this);
					this.set("contentMessage", "");
				} else {
					this._fusionChart = this.onData(results);
					if (!this._fusionChart) {
						html.destroyChildren(this.chartNode);
						this.set("contentMessage", locale.resource("ChartPlaceholderTitle"));
						Widget.prototype._buildView.call(this);
					} else {
						html.destroyChildren(this.contentNode);

						// if the widget is visible, wait until the chart is rendered to proceed further.
						// Otherwise - do not wait
						if (html.isShown(this.domNode)) {
							this._fusionChart.addEventListener("rendered", () => {
								this._postView();
							});
						} else {
							this._postView();
						}
					}
				}
			});
		},

		_refreshData: function () {
			// summary: reset data stores and levels if there are column matrices
			this._resetLevels();
			this.inherited(arguments);
		},

		_resolveView: function () {
			// summary: do not allow custom views if no relationship
			if (!this.relRoot) {
				this.prefClass = null;
			}

			this.inherited(arguments);
		}
	});
});